import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesUsuarios {
  ler: boolean;
  criar: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `auth`
 * (`apps/api/src/modules/auth/auth.routes.ts`, `POST/GET/PATCH
 * /auth/usuarios*`): só `admin` (curinga `*`) tem acesso — nenhum outro
 * papel foi seedado para `auth` em nenhuma migration. Usado apenas para
 * decidir o que mostrar na UI — a autorização real é sempre revalidada
 * pelo backend.
 */
export function permissoesUsuarios(papel: PapelUsuario): PermissoesUsuarios {
  if (papel === 'admin') return { ler: true, criar: true, atualizar: true };
  return { ler: false, criar: false, atualizar: false };
}
